"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PriceContainer = _styledComponents.default.div`
  & span[class*='Spanstyle__Span'] {
    display: inline-block;
  }
`;
const BusinessSolutionCardHeader = _ref => {
  var _businessSolution$sel;
  let {
    businessSolution,
    isAdditionalBusinessSolution,
    businessSolutionIndex
  } = _ref;
  const getConfiguredPriceType = (priceType, hasInitialPrice) => {
    if (priceType === _constants.PRICE_TYPES.UP_FRONT && !hasInitialPrice) {
      return _services.locale.localeString('Recommendation.StickyFooterTotal');
    } else if (priceType === _constants.PRICE_TYPES.UP_FRONT && hasInitialPrice) {
      return _services.locale.localeString('Recommendation.StickyFooterInitial');
    } else {
      return _services.locale.localeString('Recommendation.StickyFooterMonthly');
    }
  };
  const prices = businessSolution === null || businessSolution === void 0 ? void 0 : (_businessSolution$sel = businessSolution.selectedVariant) === null || _businessSolution$sel === void 0 ? void 0 : _businessSolution$sel.price;
  // if the prices has only recurring price and no other initial value, add initial price with free (0) value
  const isOnlyRecurring = prices.length === 1 && (prices === null || prices === void 0 ? void 0 : prices.find(p => p.priceType === _constants.PRICE_TYPES.RECURRING));
  if (isOnlyRecurring) {
    prices.push({
      priceType: _constants.PRICE_TYPES.UP_FRONT,
      isFreeCost: true
    });
  }
  const pricesLength = prices.length;
  const headerLayoutArray = pricesLength > 1 ? [8, 2, 2] : [10, 2];
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 2
    },
    layout: isAdditionalBusinessSolution ? {
      sm: headerLayoutArray
    } : {
      sm: headerLayoutArray
    },
    spacing: 3,
    verticalAlign: "top",
    justify: "right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: `recommendation-broadband-name`
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextStack, {
    size: 1,
    level: 2,
    justify: "left",
    text: {
      main: businessSolution.productName,
      suffix: businessSolution.productDescription
    },
    dataAttributes: {
      'data-test-id': `product-name-${businessSolutionIndex}`
    }
  })), prices.map((price, index) => /*#__PURE__*/_react.default.createElement(PriceContainer, {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextStack, {
    size: 1,
    level: 2,
    justify: "center",
    text: {
      prefix: getConfiguredPriceType(price.priceType, pricesLength > 1),
      main: price.isFreeCost ? _services.locale.localeString('Recommendation.FreeCost') : _services.locale.formatPrice(price.priceValue),
      suffix: price.discount && `Additional discount of ${_services.locale.formatPrice(price.discount)} with Vodafone mobile`
    },
    dataAttributes: {
      'data-test-id': `${price.priceType === _constants.PRICE_TYPES.UP_FRONT && pricesLength > 1 ? 'initial-contribution' : 'price-type'}-${businessSolutionIndex}`
    }
  }))));
};
var _default = BusinessSolutionCardHeader;
exports.default = _default;